import React, { useEffect } from 'react';
import { YEAR, COLLEGE_SINGLE } from '../../utils/ConstantsMain';
import Photo from '../AddHolders/Photo';
import { withStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { activeDeleteImages } from '../../store/actions/DeleteImageAction';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  TextField,
  Button,
} from '@material-ui/core';
import "./addAwards.scss";

const styles = () => ({
  form: {
    padding: 16,
    borderRadius: 4,
    margin: '20px 0 30px 0',
    border: '1px solid #e7e7e7',
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  TextField: {
    maxWidth: '536px',
    margin: 0,
  },
  pictureContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    margin: 0,
    padding: 0,
    textTransform: 'capitalize',
  },
  year: {
    maxWidth: 304,
    '@media screen and (max-width: 768.98px)': {
      maxWidth: 536,
    },
  },
  autoCompleteTextField: {
    maxWidth: 536,
    margin: '0 0 2px',
    '& .MuiInputLabel-marginDense': {
      transform: 'translate(14px, 16px) scale(1) !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
      bottom: 0,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important',
      zIndex: 10,
      right: 'unset',
      backgroundColor: '#fff',
      height: 'fit-content',
    },
  },
});

const LawyerAwardForm = props => {

  const {
    award,
    awardsHelper,
    handleChange,
    handleBlur,  
    touched,
    errors,
    classes,
    index,
    setFieldValue,
    handleCancel,
    flagEdit,
    cancelData,
    setCancelData,
    erase,
    setErase,
    activeDeleteImages,
    nElem
  } = props;

  useEffect(() => {
    if (erase) {
      setFieldValue(`awardsLawyer[${index}].myImageAward`, '')
      activeDeleteImages(
        `awardsLawyer[${index}].myImageAward`,
        index,
        false
      )
      setErase(false)
    }
  }, [
    erase,
    index,
    setErase,
    setFieldValue,
    activeDeleteImages,
  ])

  const deleteSubForm = () => {
    if (erase) {
      setFieldValue(`awardsLawyer[${index}].myImageAward`, '')
      activeDeleteImages(
        `awardsLawyer[${index}].myImageAward`,
        index,
        false
      )
      setErase(false)
    }
    awardsHelper.remove(index)
  }

  const handleTagSelectSingle = (value, field) => {
    if (value == null)
    value = ''
    setFieldValue(field, value);
  };

  return (
    <div className={classes.form}>
      <TextField
        name={`awardsLawyer[${index}].name`}
        label="Nombre del premio"
        id={`awardsLawyer[${index}].name`}
        type="text"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={award && award.name ? award.name : ''}
        helperText={
          touched &&
          touched.award &&
          touched.award[index] &&
          touched.award[index].name &&
          errors &&
          errors.award &&
          errors.award[index] &&
          errors.award[index].name ?
          errors.award[index].name :
          ''
        }
        error={
          touched &&
          touched.award &&
          touched.award[index] &&
          touched.award[index].name &&
          errors &&
          errors.award &&
          errors.award[index] &&
          errors.award[index].name ?
          true : false
        }
        fullWidth
        className={classes.TextField}
      />

      <Autocomplete
        freeSolo
        multiple={false}
        getOptionLabel={option => option}
        value={award && award.place ? award.place : ''}
        id={`awardsLawyer[${index}].place`}
        options={COLLEGE_SINGLE}
        filterSelectedOptions
        disableCloseOnSelect={false}
        blurOnSelect ={true}
        size={'small'}
        autoSelect={true}
        onChange={(event, value) => {
          handleTagSelectSingle(value, `awardsLawyer[${index}].place`)
        }}
        renderInput={params => (
          <TextField
            name={`awardsLawyer[${index}].place`}
            type="text"
            InputLabelProps={{ shrink: true }}
            onBlur={handleBlur}
            helperText={
              touched &&
              touched.award &&
              touched.award[index] &&
              touched.award[index].place &&
              errors &&
              errors.award &&
              errors.award[index] &&
              errors.award[index].place ?
              errors.award[index].place :
              ''
            }
            error={
              touched &&
              touched.award &&
              touched.award[index] &&
              touched.award[index].place &&
              errors &&
              errors.award &&
              errors.award[index] &&
              errors.award[index].place ?
              true : false
            }
            {...params}
            classes={{ root: classes.autoCompleteTextField }}
            label="Institución que avala el premio"
            variant="outlined"
          />
        )}
      />

      <FormControl
        className={classes.year}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >
          {'Año en que recibiste el premio'}
        </InputLabel> 
          <Select
            id='year'
            name={`awardsLawyer[${index}].year`}
            value={award && award.year ? award.year : []}
            onChange={handleChange}
          >
            {YEAR && YEAR.map((item, index) => (
              <MenuItem key={index} value={item.value} >
                {item.name}
              </MenuItem>
            ))}
        </Select>
        {touched &&
        touched.award &&
        touched.award[index] &&
        touched.award[index].year &&
        errors &&
        errors.award &&
        errors.award[index].year ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.award[index].year}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl>

      <p className="pictureTextAward">Puedes añadir una fotografía del premio recibido</p>

      <div className={classes.pictureContainer}>
        <Photo
          name={`awardsLawyer[${index}].myImageAward`}
          value={award.myImageAward}
          setFieldValue={setFieldValue}
          routeName='lawyers'
          subRouteName='awardImage'
          index={nElem && flagEdit === 1 ? nElem : index}
          cancelData={cancelData}
          setCancelData={setCancelData}
          setErase={setErase}
          flagEdit={flagEdit}
        />

        {index && index !== 0 ?
          <Button
            key={index}
            component="span"
            type="button"
            onClick={index && index !== 0 ? deleteSubForm : handleCancel}
            className={classes.deleteAction}
          >
              Eliminar
          </Button> : null
        }
      </div>
      
    </div>
  )
};

const mapDispatchToProps = dispatch => ({
  activeDeleteImages: (name, index, boolCancel) =>
    dispatch(activeDeleteImages(name, index, boolCancel)),
});

const LawyerAwardFormCompose = compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(LawyerAwardForm)

export default LawyerAwardFormCompose;
